import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

function OrderDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    axios.get(`https://agaram.ematixsolutions.com/api/orders/${id}`).then((res) => {
      setOrder(res.data.order);
    });
  }, [id]);

  if (!order) return <p>Loading...</p>;

  const totalQty = order.items.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "auto" }}>
      <h2>🧾 Order Details: {order.custom_order_id || order.id}</h2>
      <p><strong>User:</strong> {order.user_name}</p>
      <p><strong>Mobile:</strong> {order.mobile}</p>
      <p><strong>Address:</strong> {order.address}</p>
      <p><strong>Remarks:</strong> {order.remarks}</p>
      <p><strong>Delivery Time:</strong> {order.delivery_time}</p>

      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "20px" }}>
        <thead>
          <tr style={{ backgroundColor: "#f0f0f0" }}>
            <th style={{ border: "1px solid #ccc", padding: "10px" }}>Item</th>
            <th style={{ border: "1px solid #ccc", padding: "10px" }}>Code</th>
            <th style={{ border: "1px solid #ccc", padding: "10px" }}>Qty</th>
            <th style={{ border: "1px solid #ccc", padding: "10px" }}>Price</th>
            <th style={{ border: "1px solid #ccc", padding: "10px" }}>Total</th>
          </tr>
        </thead>
        <tbody>
          {order.items.map((item) => (
            <tr key={item.id}>
              <td style={{ border: "1px solid #ccc", padding: "10px" }}>{item.product_name}</td>
              <td style={{ border: "1px solid #ccc", padding: "10px" }}>{item.product_code}</td>
              <td style={{ border: "1px solid #ccc", padding: "10px" }}>{item.quantity}</td>
              <td style={{ border: "1px solid #ccc", padding: "10px" }}>₹{item.price}</td>
              <td style={{ border: "1px solid #ccc", padding: "10px" }}>₹{item.quantity * item.price}</td>
            </tr>
          ))}
          <tr style={{ backgroundColor: "#f9f9f9" }}>
            <td colSpan="2" style={{ padding: "10px", textAlign: "right" }}><strong>Total</strong></td>
            <td style={{ padding: "10px" }}><strong>{totalQty}</strong></td>
            <td></td>
            <td style={{ padding: "10px" }}><strong>₹{order.total_amount}</strong></td>
          </tr>
        </tbody>
      </table>

      <button onClick={() => navigate(-1)} style={{ marginTop: "20px" }}>⬅ Back</button>
    </div>
  );
}

export default OrderDetail;
